// Communication Management copy of NotifyStudentSection (UserCreationSection).
// All data / GraphQL / form logic is identical to the original
// ../../settings/notifystudent/NotifyStudentSection.jsx — only the design changes:
// Branch/Class/Section/Category become filter dropdowns (default = all) and the
// table + modal reuse the Parent Notification design (.comm-pn-page / .comm-pn-modal).
// Separate file so the standalone Notify Students module is unaffected.

import React, { Component } from 'react'
import MultiSelect from "react-multi-select-component";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import CommNotifyStudentModal from "./CommNotifyStudentModal";
import NotificationPageShimmer from '../../preloader/NotificationShimmer';
import '../../settings/notifystudent/_notifystudent.scss';
import './_commParentNotification.scss';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import moment from 'moment';
import { withApollo } from "react-apollo";
import { canView } from "../../../../utils/modulePermissions";
import {
    attachModuleGuard,
    AccessDeniedModal,
    AccessDeniedCard,
} from "../../../../utils/moduleGuard";
import {
    getAuthorizedBranchIds,
    getAuthorizedClassIds,
    getAuthorizedSectionIds,
    getAuthorizedSubjectIds,
    filterByAuthorizedIds
} from "../../../utils/authHelper";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";

const showStream = (classId) => String(classId) === "1" || String(classId) === "2";

const GET_STREAMS = gql`
  query getStreams {
    getStreams {
      id
      stream
      classes
    }
  }
`;

// /communication-management/* → "communication_management". Match on module_key only.
const COMMUNICATION_MODULE = ["communication_management"];

const ADDNOTIFYSTUDENT = gql`
  mutation($params:SendInstituteNotification) {
        sendInstituteNotification(params: $params)
  }
`;
const ADDNOTIFYSTUDENTONE = gql`
  mutation($params:SendNotificationIds1) {
        studentSendNotification(params: $params)
  }
`;
const FETCH_NOTIFYSTUDENTS = gql`
query($institution_id: Int!) {
    getInstituteNotificaton(institution_id: $institution_id){
        title
        description
        class_ids
        category_ids
        branch_ids
        section_ids
        student_ids
        timestamp
    }
}
`;
const GET_CLASSES = gql`
  query getExamClasses($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        stream_id
        section_name
        class_id
        subjects {
          subject_id
          subject_name
        }
      }
    }
  }
`;

class CommNotifyStudentSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableHeaderData: { Title: 'Notification Table' },
            modalShow: false,
            modalShow1: false,
            image: "",
            image_filename: "",
            formValid: false,
            currentStep: "1",
            submitError: "",
            classname: "",
            classnamevalue: "",
            branchvalue: [],
            branch: [],
            category: "",
            categoryvalue: "",
            sectionvalue: [],
            section: [],
            title: "",
            message: "",
            ldescription: "",
            formErrors: { classname: "", branch: "", category: "", section: "", title: "", message: "", ldescription: "" },
            classnameValid: true,
            branchValid: true,
            categoryValid: false,
            sectionValid: true,
            titleValid: false,
            messageValid: false,
            ldescriptionValid: false,
            SendInstituteNotification: '',
            uploadfile: "",
            fileUuid: "",
            file_extension_type: "",
            error: "",
            branches: [],

            // Filter selections (default = all once globals load)
            filtersInit: false,
            selectedBranches: [],
            selectedClasses: [],
            selectedSections: [],
            accessDeniedShow: false,
        }

        this.guard = attachModuleGuard(this, COMMUNICATION_MODULE);
    }

    // "Send Notification" — opens CommNotifyStudentModal (a dumb form that calls back
    // into handleFormSubmit here). Gating the opener stops the write; the button stays
    // visible and clickable. handleFormSubmit re-checks at the submit.
    parentStateSetGuarded = () => {
        if (!this.guard.requireEdit()) return;
        this.parentStateSet();
    };

    componentDidMount() {
        // is_view === 0 → don't fetch the branch dropdown. This is an imperative
        // client.query() call, so the `skip` on the HOCs below doesn't cover it.
        if (!this.guard.canView()) return;

        this.fetchBranches();
        this.maybeInitFilters();
        // Branch comes from the header (NavbarOne). Re-running the init rebuilds the
        // table's Branch/Class/Section defaults from the new scope. fetchBranches()
        // is NOT re-scoped: it feeds the send-notification form, which writes branch_ids.
        this.offBranchScope = onBranchScopeChange(() =>
            this.setState({ filtersInit: false }, this.maybeInitFilters)
        );
    }

    componentDidUpdate() {
        this.maybeInitFilters();
    }

    componentWillUnmount() {
        if (this.offBranchScope) this.offBranchScope();
    }

    maybeInitFilters = () => {
        const branchesData = (this.props.getBranchesQuery && this.props.getBranchesQuery.getBranches) || [];
        const classesData = (this.props.getClassesQuery && this.props.getClassesQuery.getExamClasses) || [];

        if (!this.state.filtersInit && (branchesData.length > 0 || classesData.length > 0)) {
            const authorizedClassIds = getAuthorizedClassIds();
            const authorizedSectionIds = getAuthorizedSectionIds();

            // The header's branch selection IS this table's branch filter, and it
            // never widens past the branches the user is authorized for.
            const branches = scopeBranches(branchesData);

            let sections = branches.flatMap((b) =>
                (b.sections || []).map((s) => ({ ...s, branch_id: b.id }))
            );
            if (authorizedSectionIds.length || authorizedClassIds.length) {
                sections = filterByAuthorizedIds(
                    filterByAuthorizedIds(sections, authorizedSectionIds, "id"),
                    authorizedClassIds,
                    "class_id"
                );
            }

            const classes = filterByAuthorizedIds(classesData, authorizedClassIds, "id");
            const streamsData = (this.props.getStreamsQuery && this.props.getStreamsQuery.getStreams) || [];
            const streamOptions = streamsData.map((st) => ({ label: st.stream, value: String(st.id) }));

            this.setState({
                filtersInit: true,
                selectedBranches: branches.map((b) => ({ label: b.branch_name, value: String(b.id) })),
                selectedClasses: classes.map((c) => ({ label: c.class, value: String(c.id) })),
                selectedSections: sections.map((s) => ({ label: s.section_name, value: String(s.id) })),
                selectedStreams: streamOptions,
            });
        }
    }

    fetchBranches = async () => {
        try {
            const institution_id = parseInt(Cookies.get("institutionid"));
            const res = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id },
                fetchPolicy: "network-only",
            });
            let branches = res.data.getBranches || [];
            const authorizedIds = getAuthorizedBranchIds();
            if (authorizedIds.length) {
                branches = branches.filter((b) => authorizedIds.includes(String(b.id)));
            }
            const allowedClasses = getAuthorizedClassIds();
            const allowedSections = getAuthorizedSectionIds();
            if (allowedClasses.length || allowedSections.length) {
                branches = branches.map((b) => ({
                    ...b,
                    sections: filterByAuthorizedIds(
                        filterByAuthorizedIds(b.sections || [], allowedSections, "id"),
                        allowedClasses,
                        "class_id"
                    ),
                }));
            }
            this.setState({ branches });
        } catch (e) {
            console.error("getBranches failed", e);
        }
    };

    // The send form's Branch multi-select pre-fills with the header's scope, so a
    // user working in one branch doesn't have to pick it again. They can still
    // narrow it — the value is saved as branch_ids on the notification.
    scopedBranchSelection = () => {
        const scoped = scopeBranches(this.state.branches || []);
        return {
            branch: scoped.map((b) => b.id),
            branchvalue: scoped.map((b) => ({ label: b.branch_name, value: b.id })),
        };
    };

    parentStateSet = () => {
        const { branch, branchvalue } = this.scopedBranchSelection();
        this.setState({
            tableHeaderData: { Title: 'Notification Table' },
            modalShow: true,
            modalShow1: false,
            formValid: false,
            currentStep: "1",
            submitError: "",
            classname: "",
            classnamevalue: "",
            branchvalue,
            branch,
            category: [],
            categoryvalue: [],
            sectionvalue: [],
            section: [],
            title: "",
            message: "",
            ldescription: "",
            formErrors: { classname: "", branch: "", category: "", section: "", title: "", message: "", ldescription: "" },
            fullnameValid: false,
            classnameValid: false,
            // Branch comes from the header, so it is valid as soon as the scope
            // resolves to at least one branch.
            branchValid: branch.length > 0,
            categoryValid: false,
            sectionValid: false,
            titleValid: false,
            messageValid: false,
            ldescriptionValid: false,
            uploadfile: "",
            fileUuid: "",
            file_extension_type: "",
            image_filename: "",
            error: ""
        });
    };

    handleMultipleSelectInputChange = (e, name) => {
        if (name == "branch") {
            let branch = [];
            let branchvalue = [];
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    branchvalue.push({ label: e[i].label, value: e[i].value });
                    branch.push(e[i].value);
                }
                this.setState({ branch, branchvalue, section: [], sectionvalue: [] }, () => {
                    this.validateField(name, "1");
                });
            }
        }
        if (name == "category") {
            let category = [];
            let categoryvalue = [];
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    categoryvalue.push({ label: e[i].label, value: e[i].value });
                    category.push(e[i].value);
                }
                this.setState({ category, categoryvalue }, () => {
                    this.validateField(name, "1");
                });
            }
        }
        if (name == "section") {
            let section = [];
            let sectionvalue = [];
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    sectionvalue.push({ label: e[i].label, value: e[i].value });
                    section.push(e[i].value);
                }
                this.setState({ section, sectionvalue }, () => {
                    this.validateField(name, "1");
                });
            }
        }
    };

    handleFormSubmit = e => {
        e.preventDefault();

        // Re-checked at submit, not only at the opener: the modal could already be open
        // when a grant changes. The two mutations below re-check independently.
        if (!this.guard.requireEdit()) return;

        if (this.state.formValid) {
            let notifystudentObj = "";
            let classn = [];
            if (this.state.classname == "0") {
                this.props.globals.globals.classes.map((item) => {
                    if (item != undefined) classn.push(item.id);
                });
            } else {
                classn = this.state.classname
            }
            notifystudentObj = {
                title: this.state.title,
                description: this.state.message,
                long_description: this.state.ldescription,
                image: this.state.uploadfile,
                class_ids: classn.toString(),
                category_ids: this.state.category.toString(),
                branch_ids: this.state.branch.toString(),
                section_ids: this.state.section.toString(),
                institution_id: parseInt(Cookies.get("institutionid"))
            };
            this.notifystudent(notifystudentObj, classn).catch(error => {
                this.setState({ submitError: error.graphQLErrors.map(x => x.message) });
            });
        } else {
            this.setState({ submitError: "Please fill all the values to proceed" });
        }
    };

    sendNotificationToStudents = () => {
        this.props.getInstituteNotificaton.refetch().then((data) => {
            let notifications = data.data.getInstituteNotificaton;
            let params = {
                notification_id: parseInt(this.state.SendInstituteNotification),
                usernames: data.data.getInstituteNotificaton[notifications.length - 1].student_ids.replace(/,\s*$/, "")
            }
            this.sendids(params).catch(error => {
                this.setState({ submitError: error.graphQLErrors.map(x => x.message) });
            });
        });
    }

    // Last gate before sendInstituteNotification leaves the client.
    notifystudent = async (params, classn) => {
        if (!this.guard.requireEdit()) return;

        await this.props.notifystudent({
            variables: { params },
            update: (store, { data }) => {
                let data1 = store.readQuery({
                    query: FETCH_NOTIFYSTUDENTS,
                    variables: { institution_id: parseInt(Cookies.get("institutionid")) }
                });
                this.setState({ SendInstituteNotification: data.sendInstituteNotification });
                const newUser = {
                    branch_ids: this.state.branch.toString(),
                    category_ids: this.state.category.toString(),
                    class_ids: classn.toString(),
                    description: this.state.message,
                    section_ids: this.state.section.toString(),
                    title: this.state.title,
                    timestamp: moment().unix(),
                    student_ids: "",
                    __typename: "InstituteNotifications"
                };
                data1.getInstituteNotificaton.unshift(newUser);
                this.sendNotificationToStudents();

                try {
                    store.writeQuery({
                        query: FETCH_NOTIFYSTUDENTS,
                        variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                        data: data1
                    });
                } catch (e) {
                    console.log("Exception", e);
                }

                if (data.SendInstituteNotification != "") {
                    this.setState({
                        tableHeaderData: { Title: 'Notification Table' },
                        modalShow1: false,
                        formValid: false,
                        currentStep: "5",
                        submitError: "",
                        classname: "",
                        classnamevalue: "",
                        branchvalue: [],
                        branch: [],
                        category: "",
                        categoryvalue: "",
                        sectionvalue: [],
                        section: [],
                        title: "",
                        message: "",
                        ldescription: "",
                        formErrors: { classname: "", branch: "", category: "", section: "", title: "", message: "", ldescription: "" },
                        classnameValid: false,
                        branchValid: false,
                        categoryValid: false,
                        sectionValid: false,
                        titleValid: false,
                        messageValid: false,
                        ldescriptionValid: false
                    });
                    setTimeout(() => { this.SetpageLoad(); }, 1500);
                }
            }
        });
    };

    // Last gate before studentSendNotification (the actual push to students).
    sendids = async params => {
        if (!this.guard.requireEdit()) return;

        await this.props.sendids({ variables: { params }, update: () => { } });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, modalShow: false });
    };

    handleInputChange = async (e) => {
        if (e.target.files && e.target.files[0]) {
            // Picking a file fires the FileUpload mutation immediately, so this branch is
            // a write → is_edit. (The `else` branch below is just a text field — a plain
            // local edit, left ungated.) The input stays enabled; the upload is what gets
            // stopped. Reset it so the rejected file isn't left sitting in the control.
            if (!this.guard.requireEdit()) { e.target.value = ""; return; }

            const selectedFile = e.target.files[0];
            const fileType = selectedFile.type;
            const fileName = selectedFile.name.toLowerCase();
            const isPdf = fileType === "application/pdf" || fileName.endsWith(".pdf");
            const isImage = fileType.startsWith("image/");

            if (!isPdf && !isImage) {
                this.setState({ error: "Only PDF and Image files are allowed.", image_filename: "" });
                return;
            }
            this.setState({ error: "", image_filename: "Uploading..." });

            const reader = new FileReader();
            reader.onload = async () => {
                const base64Data = reader.result;
                try {
                    const response = await this.props.client.mutate({
                        mutation: gql`
                            mutation FileUpload($params: FileUploadInput!) {
                                fileUpload(params: $params) {
                                    uuid
                                    file_url
                                    file_extension_type
                                    file_name
                                }
                            }
                        `,
                        variables: {
                            params: {
                                category: "notification",
                                client_id: parseInt(Cookies.get("institutionid")),
                                file: [{ img: base64Data, filename: selectedFile.name }]
                            }
                        }
                    });
                    const result = response?.data?.fileUpload;
                    const fileData = Array.isArray(result) ? result[0] : result;
                    if (fileData) {
                        this.setState({
                            uploadfile: fileData.file_url,
                            fileUuid: fileData.uuid,
                            file_extension_type: fileData.file_extension_type,
                            image_filename: fileData.file_name
                        });
                    }
                } catch (err) {
                    console.error("Upload error:", err);
                    this.setState({ error: "Upload failed", image_filename: "" });
                }
            };
            reader.readAsDataURL(selectedFile);
        } else {
            const name = e.target.name;
            const value = e.target.value;
            this.setState({ [name]: value });
        }
    };

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;
        if (name == "classname") {
            if (value != "0") {
                let classnameData = this.props.globals.globals.classes.find((a) => a.id == value);
                this.setState({
                    classnamevalue: { value: classnameData.id, label: classnameData.class },
                    section: [],
                    sectionvalue: []
                });
            } else {
                this.setState({
                    classnamevalue: { value: "0", label: "Select All" },
                    section: [],
                    sectionvalue: []
                });
            }
        }
        if (name == "category") {
            if (value != "0") {
                let categoryData = this.props.globals.globals.globalCategories.find((a) => a.id == value);
                this.setState({ categoryvalue: { value: categoryData.id, label: categoryData.category_name } });
            } else {
                this.setState({ categoryvalue: { value: "0", label: "Select" } });
            }
        }
        this.setState({ [name]: value }, () => { this.validateField(name, value); });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let classnameValid = this.state.classnameValid;
        let branchValid = this.state.branchValid;
        let categoryValid = this.state.categoryValid;
        let sectionValid = this.state.sectionValid;
        let titleValid = this.state.titleValid;
        let messageValid = this.state.messageValid;
        let ldescriptionValid = this.state.ldescriptionValid;

        switch (fieldName) {
            case "classname":
                if (value.length == "") { classnameValid = false; fieldValidationErrors.classname = "class Cannot Be Empty"; }
                else { classnameValid = true; fieldValidationErrors.classname = ""; }
                break;
            case "branch":
                if (value.length == "") { branchValid = false; fieldValidationErrors.branch = "branch Cannot Be Empty"; }
                else { branchValid = true; fieldValidationErrors.branch = ""; }
                break;
            case "category":
                if (value.length == "") { categoryValid = false; fieldValidationErrors.category = "category Cannot Be Empty"; }
                else { categoryValid = true; fieldValidationErrors.category = ""; }
                break;
            case "section":
                if (value.length == "") { sectionValid = false; fieldValidationErrors.section = "section Cannot Be Empty"; }
                else { sectionValid = true; fieldValidationErrors.section = ""; }
                break;
            case "title":
                if (value.length == "") { titleValid = false; fieldValidationErrors.title = "Title Cannot Be Empty"; }
                else { titleValid = true; fieldValidationErrors.title = ""; }
                break;
            case "message":
                if (value.length == "") { messageValid = false; fieldValidationErrors.message = "Message Cannot Be Empty"; }
                else { messageValid = true; fieldValidationErrors.message = ""; }
                break;
            case "ldescription":
                if (value.length == "") { ldescriptionValid = false; fieldValidationErrors.ldescription = "long description Cannot Be Empty"; }
                else { ldescriptionValid = true; fieldValidationErrors.ldescription = ""; }
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            classnameValid, branchValid, categoryValid, sectionValid, titleValid, messageValid, ldescriptionValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({
            formValid: this.state.branchValid && this.state.sectionValid && this.state.titleValid && this.state.messageValid && this.state.ldescriptionValid
        });
        if (this.state.formValid) { this.setState({ submitError: "" }); }
    }

    onHideFun = () => { this.setState({ modalShow: false }); }

    handleEditorChange = (arg) => {
        const content = arg && arg.target && typeof arg.target.getContent === "function" ? arg.target.getContent() : arg;
        this.setState({ ldescription: content }, () => { this.validateField("ldescription", "1"); });
    }

    articlecolumns = [
        {
            dataField: "sno",
            text: "S.No",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "title",
            text: "Notification",
            sort: true,
            formatter: (cell) => (
                <span className="cpn-title-text" title={cell || ""}>{cell || "—"}</span>
            ),
        },
        {
            dataField: "branch",
            text: "Branch",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "class",
            text: "Class",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "section",
            text: "Section",
            formatter: (cell) => <span className="cpn-meta cpn-bcs" title={cell || ""}>{cell || "—"}</span>,
        },
        {
            dataField: "date",
            text: "Date",
            sort: true,
            formatter: (cell) => <span className="cpn-meta"><i className="fal fa-calendar-alt" />{cell}</span>,
        },
        {
            dataField: "time",
            text: "Time",
            sort: true,
            formatter: (cell) => <span className="cpn-meta"><i className="fal fa-clock" />{cell}</span>,
        },
        {
            dataField: "description",
            text: "Message",
            sort: true,
            formatter: (cell) => <span className="cpn-desc">{cell || "—"}</span>,
        },
    ];

    defaultSorted = [{ dataField: "date", order: "desc" }];

    tableUserData(notifystudent) {
        const g = (this.props.globals && this.props.globals.globals) || {};
        const bMap = {}, cMap = {}, sMap = {};
        (g.globalBranches || []).forEach((b) => { bMap[String(b.id)] = b.branch_name; });
        (g.classes || []).forEach((c) => { cMap[String(c.id)] = c.class; });
        (g.globalSections || []).forEach((s) => { sMap[String(s.id)] = s.section_name; });
        const namesFrom = (ids, map) => ids.map((id) => map[id]).filter(Boolean).join(", ") || "All";

        const selBArr = this.state.selectedBranches.map((o) => String(o.value));
        const selCArr = this.state.selectedClasses.map((o) => String(o.value));
        const selSArr = this.state.selectedSections.map((o) => String(o.value));
        const selB = new Set(selBArr);
        const selC = new Set(selCArr);
        const selS = new Set(selSArr);
        // Constrain a dimension only when the user has narrowed it to a proper
        // subset (not "all" and not empty). Avoids the filtersInit timing gate.
        const conB = selBArr.length > 0 && selBArr.length < Object.keys(bMap).length;
        const conC = selCArr.length > 0 && selCArr.length < Object.keys(cMap).length;
        const conS = selSArr.length > 0 && selSArr.length < Object.keys(sMap).length;

        const newArray = [];
        (notifystudent || []).forEach((mapdata) => {
            const recB = (mapdata.branch_ids || "").split(",").map((s) => s.trim()).filter(Boolean);
            const recC = (mapdata.class_ids || "").split(",").map((s) => s.trim()).filter(Boolean);
            const recS = (mapdata.section_ids || "").split(",").map((s) => s.trim()).filter(Boolean);

            const bMatch = !conB || recB.length === 0 || recB.some((id) => selB.has(id));
            const cMatch = !conC || recC.length === 0 || recC.some((id) => selC.has(id));
            const sMatch = !conS || recS.length === 0 || recS.some((id) => selS.has(id));
            if (!(bMatch && cMatch && sMatch)) return;

            newArray.push({
                title: mapdata.title,
                description: mapdata.description,
                branch: namesFrom(recB, bMap),
                class: namesFrom(recC, cMap),
                section: namesFrom(recS, sMap),
                date: moment.unix(mapdata.timestamp).format("YYYY/MM/DD"),
                time: moment.unix(mapdata.timestamp).format("LT"),
            });
        });
        return newArray;
    }

    render() {
        // is_view === 0 → the notification data is never rendered, and the two queries
        // below are skipped so nothing is fetched. This MUST stay above the prop reads
        // that follow.
        if (!this.guard.canView()) {
            return <AccessDeniedCard />;
        }

        const getInstituteNotificaton = this.props.getInstituteNotificaton || {};
        const branchesQuery = this.props.getBranchesQuery || {};
        const classesQuery = this.props.getClassesQuery || {};

        const loading3 = getInstituteNotificaton.loading;
        const error3 = getInstituteNotificaton.error;

        const loading1 = branchesQuery.loading || classesQuery.loading;
        const error1 = branchesQuery.error || classesQuery.error;

        if (loading3 || loading1) return <NotificationPageShimmer rows={6} cols={6} />;
        if (error3 !== undefined) { alert("Server Error. " + error3.message); return null; }
        if (error1 !== undefined) { alert("Server Error. " + error1.message); return null; }

        const branchesData = branchesQuery.getBranches || [];
        const classesData = classesQuery.getExamClasses || [];

        const authorizedClassIds = getAuthorizedClassIds();
        const authorizedSectionIds = getAuthorizedSectionIds();

        // The header's branch selection IS this table's branch filter.
        const allowedBranches = scopeBranches(branchesData);

        let allowedSections = allowedBranches.flatMap((b) =>
            (b.sections || []).map((s) => ({ ...s, branch_id: b.id }))
        );
        if (authorizedSectionIds.length || authorizedClassIds.length) {
            allowedSections = filterByAuthorizedIds(
                filterByAuthorizedIds(allowedSections, authorizedSectionIds, "id"),
                authorizedClassIds,
                "class_id"
            );
        }

        const allowedClasses = filterByAuthorizedIds(classesData, authorizedClassIds, "id");
        const streamsData = (this.props.getStreamsQuery && this.props.getStreamsQuery.getStreams) || [];

        const selectedClassIds = (this.state.selectedClasses || []).map((c) => String(c.value));
        const selectedBranchIds = (this.state.selectedBranches || []).map((b) => String(b.value));

        let relevantSections = allowedSections;
        if (selectedBranchIds.length > 0 && selectedBranchIds.length < allowedBranches.length) {
            relevantSections = relevantSections.filter((s) => selectedBranchIds.includes(String(s.branch_id)));
        }
        if (selectedClassIds.length > 0 && selectedClassIds.length < allowedClasses.length) {
            relevantSections = relevantSections.filter((s) => selectedClassIds.includes(String(s.class_id)));
        }

        const availableStreamIds = new Set(
            relevantSections.filter((s) => s.stream_id != null).map((s) => String(s.stream_id))
        );

        let streamOptions = streamsData.map((st) => ({ label: st.stream, value: String(st.id) }));
        if (availableStreamIds.size > 0) {
            streamOptions = streamOptions.filter((opt) => availableStreamIds.has(opt.value));
        }

        const selectedStreamIds = (this.state.selectedStreams || []).map((s) => String(s.value));
        if (selectedStreamIds.length > 0 && selectedStreamIds.length < streamOptions.length) {
            relevantSections = relevantSections.filter((s) => !s.stream_id || selectedStreamIds.includes(String(s.stream_id)));
        }

        const classOptions = allowedClasses.map((c) => ({ label: c.class, value: String(c.id) }));
        const sectionOptions = relevantSections.map((s) => ({ label: s.section_name, value: String(s.id) }));

        const rows = this.tableUserData(getInstituteNotificaton.getInstituteNotificaton);

        return (
            <div className="ns-page comm-pn-page comm-ns-page">
                {/* Header */}
                <div className="pn-header">
                    <div className="pn-header-left">
                        <i className="fas fa-bullhorn pn-header-icon" />
                        <div>
                            <h5 className="pn-title">Student Notifications</h5>
                            <small className="pn-subtitle">Send notifications to students and review history</small>
                        </div>
                    </div>
                    <button className="pn-send-btn" onClick={this.parentStateSetGuarded}>
                        <i className="fas fa-paper-plane" /> Send Notification
                    </button>
                </div>

                <div className="pn-table-card">
                    {/* Filter header */}
                    <div className="comm-filter-head">
                        <div className="comm-filter-title">
                            <span className="comm-filter-icon"><i className="fal fa-sliders-h" /></span>
                            Filters
                        </div>
                        <span className="pn-count">{rows.length} {rows.length === 1 ? "record" : "records"}</span>
                    </div>

                    {/* Class / Section / Category multi-select filters (default all). No
                        Branch filter — the header's branch selection scopes this page. */}
                    <div className="comm-filter-bar">
                        <div className="comm-filter-field">
                            <label><i className="fal fa-layer-group mr-1" /> Class</label>
                            <MultiSelect
                                options={classOptions}
                                value={this.state.selectedClasses}
                                onChange={(v) => this.setState({ selectedClasses: v })}
                                labelledBy="Class"
                                overrideStrings={{ allItemsAreSelected: "All Classes", selectSomeItems: "Select Class" }}
                            />
                        </div>
                        {streamOptions.length > 0 && (
                            <div className="comm-filter-field">
                                <label><i className="fal fa-water mr-1" /> Stream</label>
                                <MultiSelect
                                    options={streamOptions}
                                    value={this.state.selectedStreams || streamOptions}
                                    onChange={(v) => this.setState({ selectedStreams: v })}
                                    labelledBy="Stream"
                                    overrideStrings={{ allItemsAreSelected: "All Streams", selectSomeItems: "Select Stream" }}
                                />
                            </div>
                        )}
                        <div className="comm-filter-field">
                            <label><i className="fal fa-users mr-1" /> Section</label>
                            <MultiSelect
                                options={sectionOptions}
                                value={this.state.selectedSections}
                                onChange={(v) => this.setState({ selectedSections: v })}
                                labelledBy="Section"
                                overrideStrings={{ allItemsAreSelected: "All Sections", selectSomeItems: "Select Section" }}
                            />
                        </div>
                    </div>

                    {/* Table */}
                    <div className="comm-table-wrap">
                        <CardLessDataTableWithOutSearch
                            parentData={rows}
                            particlecolumns={this.articlecolumns}
                            defaultSorted={this.defaultSorted}
                        />
                    </div>
                </div>

                {/* Send notification popup (lazy mounted) */}
                {this.state.modalShow && (
                    <CommNotifyStudentModal
                        handleEditorChange={this.handleEditorChange}
                        handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                        classes={allowedClasses}
                        branches={scopeBranches(this.state.branches || [])}
                        parenthandleFormSubmit={this.handleFormSubmit}
                        parentselecthandleInputChange={this.selecthandleInputChange}
                        ParenthandleInputChange={this.handleInputChange}
                        show={this.state.modalShow}
                        onHide1={this.onHideFun}
                        stateData={this.state}
                    />
                )}

                {/* Shown instead of opening the modal / uploading / sending when is_edit
                    is missing. This module has no delete surface. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </div>
        )
    }
}

export default compose(
    withRouter,
    withApollo,
    graphql(FETCH_NOTIFYSTUDENTS, {
        options: props => ({
            variables: { institution_id: parseInt(Cookies.get("institutionid")) },
            fetchPolicy: 'network-only',
            nextFetchPolicy: "network-only"
        }), skip: () => !canView(COMMUNICATION_MODULE), name: "getInstituteNotificaton"
    }),
    graphql(GET_BRANCHES, {
        options: props => ({
            variables: { institution_id: parseInt(Cookies.get("institutionid")) }
        }), skip: () => !canView(COMMUNICATION_MODULE), name: "getBranchesQuery"
    }),
    graphql(GET_CLASSES, {
        options: props => ({
            variables: { id: 1 }
        }), skip: () => !canView(COMMUNICATION_MODULE), name: "getClassesQuery"
    }),
    graphql(GET_STREAMS, { skip: () => !canView(COMMUNICATION_MODULE), name: "getStreamsQuery" }),
    graphql(ADDNOTIFYSTUDENT, { name: "notifystudent" }),
    graphql(ADDNOTIFYSTUDENTONE, { name: "sendids" })
)(CommNotifyStudentSection);
